function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    fill: "#060606",
    fillRule: "evenodd",
    d: "M19.147.852A2.891 2.891 0 0 0 17.09 0c-.778 0-1.51.303-2.057.852L1.444 14.441a.554.554 0 0 0-.144.249L.022 19.279a.566.566 0 0 0 .703.699l4.589-1.303a.567.567 0 0 0 .393-.403.567.567 0 0 0-.145-.545l-2.895-2.902L13.954 3.537l2.507 2.508-9.706 9.692a.567.567 0 1 0 .802.805l11.59-11.573c.551-.55.854-1.282.854-2.059 0-.777-.303-1.508-.854-2.058zM4.075 17.845l-2.686.764.75-2.703 1.936 1.939zm14.27-13.681l-1.079 1.078-2.509-2.508 1.078-1.078c.335-.335.78-.52 1.255-.52.475 0 .92.185 1.255.52.336.335.519.78.519 1.254s-.183.919-.519 1.254z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.74de3698c7e26a4ead2c6e1691e4d74a.svg";
export { ForwardRef as ReactComponent };